import { useEffect, useRef } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { pwaInfo } from 'virtual:pwa-info'
import { useToast } from '@/components/ui/use-toast'
import { ToastAction } from '@/components/ui/toast'

console.log(pwaInfo)

export function UpdatePrompt() {
  const { toast } = useToast()
  // replaced dynamically
  const buildDate = '__DATE__'
  // replaced dyanmicaly
  const reloadSW = '__RELOAD_SW__'

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      console.log(`Service Worker at: ${swUrl}`)
      // @ts-expect-error just ignore
      if (reloadSW === 'true') {
        r &&
          setInterval(() => {
            console.log('Checking for sw update')
            r.update()
          }, 20000 /* 20s for testing purposes */)
      } else {
        console.log('SW Registered: ' + r)
      }
    },
    onRegisterError(error) {
      console.log('SW registration error', error)
    },
  })

  const renderedRef = useRef(false)
  useEffect(() => {
    if (offlineReady || needRefresh) {
      if (renderedRef.current) {
        return
      }

      const close = () => {
        setOfflineReady(false)
        setNeedRefresh(false)
      }
      toast({
        title: needRefresh
          ? 'Update available.'
          : 'App is ready to work offline.',
        description: `Version: ${buildDate}`,
        // @ts-expect-error wrong typings
        onDismiss: () => {
          close()
        },
        action: (
          <ToastAction
            altText="Reload App"
            onClick={() => {
              updateServiceWorker(true)
            }}
          >
            Reload
          </ToastAction>
        ),
      })
      renderedRef.current = true
    }
  }, [
    offlineReady,
    needRefresh,
    toast,
    updateServiceWorker,
    setNeedRefresh,
    setOfflineReady,
  ])

  return null
}
